import React, { useEffect, useRef } from 'react'
import { Col, Row, Form } from 'react-bootstrap'
import Button from '@components/common/Button/Button.component'
import { TooltipComponent } from '@syncfusion/ej2-react-popups'
import Avatar from '@components/common/Avatar/Avatar.component'

interface InsuranceActionProps {
  handleAddInsuranceClick: () => void
  onSubmitClaim: () => void
  hasInsurancePlan: boolean
  familyMembersInfo?: {
    familyMembers: any[]
    showFamilyMembers: boolean
    setShowFamilyMembers: (showFamilyMembers: boolean) => void
    selectedFamilyMemberId: any
    setSelectedFamilyMemberId: (selectedFamilyMemberId: string) => void
  }
  disabled?: boolean
}

const InsuranceAction: React.FC<InsuranceActionProps> = ({
  handleAddInsuranceClick,
  onSubmitClaim,
  hasInsurancePlan,
  familyMembersInfo,
  disabled = false,
}) => {
  const tooltipRefs = useRef<TooltipComponent[]>([])
  useEffect(() => {
    if (
      familyMembersInfo?.showFamilyMembers &&
      familyMembersInfo?.selectedFamilyMemberId &&
      familyMembersInfo?.familyMembers &&
      tooltipRefs?.current?.length > 0
    ) {
      tooltipRefs.current.forEach((tooltip) => {
        tooltip.close()
      })
      const index = familyMembersInfo.familyMembers.findIndex(
        (member) =>
          member.member_id === familyMembersInfo.selectedFamilyMemberId,
      )
      tooltipRefs.current[index].open()
    }
  }, [
    familyMembersInfo?.showFamilyMembers,
    familyMembersInfo?.selectedFamilyMemberId,
    familyMembersInfo?.familyMembers,
    tooltipRefs?.current?.length,
  ])
  return (
    <div className="section-insurance-actions">
      <Row>
        <Col>
          <Row
            style={{
              borderBottom: '1px solid var(--blue-200)',
              paddingBottom: '8px',
              paddingLeft: '155px',
            }}
          >
            {familyMembersInfo && (
              <Col md={6} className="text-start">
                <div className="mt-1 mb-2 action-buttons-container show-family-members-switch">
                  <Form.Check
                    type="switch"
                    id="show-family-members-switch"
                    label="Show family members:"
                    checked={familyMembersInfo.showFamilyMembers}
                    onChange={(e) => {
                      familyMembersInfo.setShowFamilyMembers(e.target.checked)
                      setTimeout(() => {
                        const formCheckInput = e?.target
                          ?.closest('.form-check')
                          ?.querySelector('.form-check-input')
                        if (formCheckInput instanceof HTMLInputElement) {
                          formCheckInput.blur()
                        }
                      }, 100)
                    }}
                  />
                  {familyMembersInfo.showFamilyMembers && (
                    <>
                      {familyMembersInfo.familyMembers.map((member, index) => (
                        <div
                          className="member-img-wrapper"
                          key={member.patient_id}
                        >
                          <TooltipComponent
                            key={index}
                            ref={(el) => {
                              if (el) {
                                tooltipRefs.current[index] = el
                              }
                            }}
                            id="member-tray-tooltip"
                            content={`${member.first_name} ${member.last_name} · ${member.relation_to_patient}`}
                            position="TopCenter"
                            tabIndex={0}
                            opensOn="Custom"
                          >
                            <button
                              type="button"
                              className={`unstyled-button member-img-container ${member.member_id === familyMembersInfo.selectedFamilyMemberId ? 'selected' : ''}`}
                              aria-label={`Select ${member.first_name} ${member.last_name}`}
                              onClick={() =>
                                familyMembersInfo.setSelectedFamilyMemberId(
                                  member.member_id,
                                )
                              }
                            >
                              <Avatar
                                source={
                                  member?.photo_file?.file_path ??
                                  member?.photo ??
                                  'https://cdn-icons-png.flaticon.com/128/9131/9131478.png'
                                }
                                alt=""
                                style={{ borderRadius: '6px' }}
                              />
                            </button>
                          </TooltipComponent>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </Col>
            )}
            <Col md={familyMembersInfo ? 6 : 12} className="text-end">
              <div className="mb-2 action-buttons-container">
                <Button
                  size="md"
                  className="button-secondary me-1"
                  onClick={onSubmitClaim}
                  disabled={!hasInsurancePlan || disabled}
                >
                  Submit claim
                </Button>
                <Button
                  size="md"
                  className="button-primary ms-2"
                  onClick={handleAddInsuranceClick}
                  disabled={disabled}
                >
                  Add plan
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default InsuranceAction
